
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.659 11.42c-.092-.091-.184-.183-.276-.183-.183-.092-.459-.092-.734 0-.092.092-.184.092-.276.183l-1.836 1.837a.888.888 0 000 1.285.888.888 0 001.285 0l.276-.275v3.305c0 .55.367.918.918.918.55 0 .918-.367.918-.918v-3.305l.276.275c.183.184.459.275.642.275.184 0 .46-.091.643-.275a.888.888 0 000-1.285l-1.836-1.837z","fill":"#A6ADB5","stroke":"#E8E9ED","stroke-width":".2"}}),_c('path',{attrs:{"d":"M16.994 8.024c-.275-.642-.642-1.285-1.193-1.744a5.139 5.139 0 00-4.223-1.47c-.092-.183-.276-.275-.367-.366-.827-1.01-2.112-1.561-3.49-1.561-1.376 0-2.662.55-3.58 1.469a5.068 5.068 0 00-1.469 3.58v.276c-.183.183-.459.275-.643.55-.826.735-1.193 1.837-1.193 2.939 0 2.203 1.836 4.04 4.131 4.04.551 0 .918-.368.918-.919 0-.55-.367-.918-.918-.918a2.273 2.273 0 01-2.295-2.295c0-.643.276-1.194.643-1.653a2.79 2.79 0 01.642-.459c.368-.183.643-.55.551-1.01v-.55c0-.827.368-1.653.918-2.296 1.194-1.193 3.306-1.193 4.5 0 .183.184.366.367.458.643.184.367.643.459 1.01.367.367-.092.643-.092.918-.092.827 0 1.653.367 2.295.918.368.368.643.827.827 1.377.091.276.275.46.55.643a2.32 2.32 0 011.378 2.112c0 .642-.276 1.193-.643 1.652-.459.46-1.01.643-1.653.643-.55 0-.918.367-.918.918s.368.918.918.918c1.102 0 2.112-.459 2.938-1.193.827-.735 1.194-1.836 1.194-2.938 0-1.561-.826-2.938-2.204-3.58z","fill":"#A6ADB5"}})])
          )
        }
      }
    